import Vue from "vue";
import { VueClass } from "vue-class-component/lib/declarations";
import { RegForm } from "./components";

import "@/plugins/vue-imask.client";
import "@/plugins/vue-recaptcha.client";

import "@/assets/styles/vars.css";
import "@/assets/styles/common.css";
import "@/assets/styles/transitions.css";

Vue.config.productionTip = false;

type AppForm = {
  form: VueClass<any>;
  mountElements: NodeListOf<HTMLElement>;
};

const AppsList: Array<AppForm> = [];

const registrationForms: NodeListOf<HTMLElement> = document.querySelectorAll(
  "[data-registration-form]"
);

AppsList.push({
  form: RegForm,
  mountElements: registrationForms
});

for (const { mountElements, form } of AppsList) {
  for (const mountElement of mountElements) {
    const {
      vueAppName
    }: { vueAppName?: any } = mountElement.dataset as DOMStringMap;

    const formApp = new Vue({
      render: h => h(form)
    }).$mount(mountElement);

    if (vueAppName !== undefined) {
      const appName: any = `vueApp_${vueAppName}`;
      (window as { [key: string]: any })[appName] = formApp;
    }
  }
}
